import '../../vendor/jquery.limit.min';

window.Reverb = window.Reverb || {};
Reverb.CharacterLimit = (function () {
  const fieldSelector = '[data-character-limit]';
  const characterLeftCounter = '[data-characters-left]';
  const charCounter = '[data-character-counter]';

  function init() {
    limitFieldCharacters();
    bindFocusEvents();
  }

  function limitFieldCharacters() {
    const field = $(fieldSelector);


    const charLimit = field.prop('maxlength');

    if (field.length > 0) {
      field.limit(charLimit, characterLeftCounter);
    }
  }

  function bindFocusEvents() {
    $(document).on('focus', fieldSelector, () => {
      $(charCounter).fadeIn();
    });

    $(document).on('blur', fieldSelector, () => {
      $(charCounter).fadeOut();
    });
  }

  return {
    init,
  };
}());

$(Reverb.CharacterLimit.init);



// WEBPACK FOOTER //
// ./src/components/legacy/character_limit.js